import * as React from "react";

function SvgExponea(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1800 1800"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path fill="#ffd500" d="M-139-107h2072v2000H-139z" />
      <path
        fill="#1c1733"
        d="M790.7 789h-220v440h-220v220h1100.1v-220H790.7v-220h660.1V789h-440.1V568.9h440.1v-220H790.7z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgExponea);
